import type { AuditableEntity, AuditableGridDisplay } from "./AuditableEntity";
import type { Campaign } from "./Campaign";

export const RecordingOption = {
    VOICEMAIL: "voicemail_drop",
    IVR: "ivr",
    AGENT_VOICEMAIL: "agent_voicemail",
} as const;

export type RecordingType = (typeof RecordingOption)[keyof typeof RecordingOption];

interface PrerecordedVoiceMessageBase {
    id: string;
    isDefault: boolean;
    friendlyName: string;
    type: RecordingType;
    recordingFilename: string;
    url: string;
    phoneCallCampaigns?: Array<{
        id: string;
        campaign?: {
            id: string;
            friendlyId: string;
            state: string;
            name: string;
        };
    }>;
    subBrands?: Array<string>;
}

export type PrerecordedVoiceMessage = PrerecordedVoiceMessageBase & AuditableEntity;

export type PrerecordedVoiceMessageGrid = PrerecordedVoiceMessageBase & AuditableGridDisplay;

export interface PrerecordedVoiceMessageDrop extends PrerecordedVoiceMessageGrid {
    campaigns?: Partial<Campaign>[];
}
